import React from 'react'
import CustomLink from '@/shared/components/customLink'
import { BowlerDataRowType } from '../types'

export default function BowlerDataRow({ bowler, table }: BowlerDataRowType) {
  const b = bowler?.oBowler
  const playerSlug = b?.oSeo?.sSlug
  return (
    <tr className={`${bowler.highlight && 'highlight'}`}>
      {b?.eTagStatus === 'a' ? (
        <td>
          {playerSlug ? (
            <CustomLink href={`/${playerSlug}`} prefetch={false}>
              {b?.sFullName || b?.sShortName}
              {b?.isCaptain && <span className="ps-1">(c)</span>}
              {b?.isWk && <span className="ps-1">(wk)</span>}
            </CustomLink>
          ) : (
            <span>
              {b?.sFullName || b?.sShortName}
              {b?.isCaptain && <span className="ps-1">(c)</span>}
              {b?.isWk && <span className="ps-1">(wk)</span>}
            </span>
          )}
        </td>
      ) : (
        <td>{b?.sFullName || b?.sShortName}</td>
      )}
      {Object.keys(table)?.map((value: string) => {
        return <td key={value}>{bowler[value]}</td>
      })}
    </tr>
  )
}
